import dynamic from "next/dynamic";
const VideoPage = dynamic(() => import("@/screens/VideoPage"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
// import VideoPage from "@/screens/VideoPage";
// import PageLayout from "@/screens/Layout/PageLayout";
import useIsMobile from "@/hooks/useIsMobile";

export default function Category({
  latestStoryData = null,
  latestVideoData = null,
  videoPageData = null,
}) {
  
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <VideoPage
          isMobileDevice={isMobileDevice}
          videoPageData={videoPageData}
        />
      </PageLayout>
    </>
  );
}


export const getServerSideProps = async (ctx) => {
  
  
  const { logger } = await import("@/utils/logging/log-util");

  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];

    const { getLatestContentFeed, getContentByType } = await import(
      "@/handlers/content"
    );
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: page,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    const videosRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "video",
      },
    });
    
    let [latestStoryData, latestVideoData, videoPageData] = await Promise.all([
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: page,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(videosRedisKey, () =>
        getContentByType({
          type: "video",
          page: page,
          display: 12,
        })
      ),
    ]);

    // if (!latestVideoData || Object.keys(latestVideoData).length === 0) {
    //   return {
    //     notFound: true,
    //   };
    // }
    // if (!latestVideoData || Object.keys(latestVideoData).length === 0) {
    //   return {
    //     notFound: true,
    //   };
    // }


    // console.log(videoPageData , ' data i want................................................');
    
    let headerCache = videoPageData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        latestStoryData,
        latestVideoData,
        videoPageData,
        videoPageData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
